<template>
	<tr class="requirement-record" @click="showDetail">
		<td class="pa-1 normal-wrap text-center">
			{{ record.quote_number }}
		</td>
		<td class="pa-1 normal-wrap text-center">{{ record.logi_quote.prefecture }}</td>
		<td class="pa-1 normal-wrap text-center">{{ record.logi_quote.city }}</td>
		<td class="pa-1 normal-wrap text-center">{{ record.logi_quote.car_model }}</td>
		<td class="pa-1 normal-wrap text-center">{{ selectSupplierQuote("オーナミ") }}</td>
		<td class="pa-1 normal-wrap text-center">
			{{ selectSupplierQuote("日本ロジコム") }}
		</td>
		<td class="pa-1 normal-wrap text-center">{{ selectSupplierQuote("城南運輸") }}</td>
		<td class="pa-1 normal-wrap text-center">{{ selectSupplierQuote("大田貨物") }}</td>
		<td class="pa-1 normal-wrap text-center">{{ selectSupplierQuote("マルカ運輸") }}</td>
		<td class="pa-1 normal-wrap text-center">{{ selectSupplierQuote("赤帽") }}</td>
		<td class="pa-1 normal-wrap text-center">{{ record.quote_date | dateForRecord }}</td>
		<td class="pa-1 normal-wrap text-center">{{ record.answer_date | dateForRecord }}</td>
		<td class="pa-1 normal-wrap text-center">{{ record.quote_expiration_period }}</td>
		<td class="pa-1 normal-wrap text-center">{{ record.remarks }}</td>
		<td class="pa-1 normal-wrap text-center">
			<router-link :to="'/matters/' + referenceId" target="_blank" v-if="type == 'matter'">
				<v-icon>mdi-link</v-icon>
			</router-link>
		</td>
	</tr>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import moment from "moment/min/moment.min.js"
import common from "../../../helper/common.js"

export default {
	props: {
		record: { logi_quote: {}, quote_number: null, supplier: {} },
		recordIndex: "",
	},
	data() {
		return {
			common: common,
			flags: {},
			type: "",
			referenceId: "",
		}
	},
	filters: {
		dateForRecord: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	mounted() {
		this.setLink()
	},
	watch: {},
	methods: {
		showDetail() {
			this.$emit("showDetail", this.record)
		},
		reloadIndex() {
			this.$emit("reloadIndex")
		},
		selectSupplierQuote(word) {
			let supplierName = this.record.supplier.name
			if (word == supplierName) {
				if (this.record.logi_quote.price) {
					return this.record.logi_quote.price.toLocaleString()
				} else {
					return "回答待ち"
				}
			} else {
				return ""
			}
		},
		toDateFormat(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD")
			} else {
				return null
			}
		},
		setLink() {
			if (this.record) {
				if (this.record.matter_id) {
					this.type = "matter"
					this.referenceId = this.record.matter_id
				}
			}
		},
	},
	computed: {},
}
</script>

<style scoped lang="scss">
th,
td {
	border-left: solid gray 1px;
}
td {
	white-space: pre-wrap;
}

.requirement-record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.requirement-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
</style>
